// extracted by mini-css-extract-plugin
export default {"box":"Home_box__iDyZB","div1":"Home_div1__Wofyl","div2":"Home_div2__i7lwb","list":"Home_list__bJssQ"};